import discountRewards from '@src/static/images/logos/aaa-discount-rewards.png';
import logo from '@src/static/images/logos/AAA-logo.png';
import Image from 'next/image';
import React, { useRef, useState } from 'react';
import { useDispatch } from 'react-redux';
import Modal from 'react-responsive-modal';
import MaskedInput from 'react-text-mask';
import SimpleReactValidator from 'simple-react-validator';

const SET_PRICELEVEL = 'pricelevel/SET_PRICELEVEL';

const AAAModel = ({ open, type, title, content, onCloseModal, buttonConfirm, buttonDecline, priceLevel }) => {
	const dispatch = useDispatch();

	const validator = useRef(
		new SimpleReactValidator({
			autoForceUpdate: this,
			locale: 'en',
		})
	);
	const [membershipID, setmembershipID] = useState();
	const [memberName, setMemberName] = useState();

	const assignProductPriceLevel = priceLevel => {
		if (validator.current.allValid()) {
			dispatch({
				type: SET_PRICELEVEL,
				payload: {
					priceLevel,
				},
			});
			return true;
		} else {
			validator.current.showMessages();
			return false;
		}
	};

	return (
		<div className="feedback-modal-container">
			<Modal
				classNames={{
					modal: `feedback-modal ${type === 'alert' ? 'alert' : type === 'info' ? 'info' : ''}`,
					closeButton: 'close-btn',
				}}
				open={open}
				onClose={onCloseModal}>
				<div className="inner">
					<div className="icon">
						{type === 'alert' ? (
							<i className="fas fa-exclamation-triangle"></i>
						) : type === 'info' ? (
							<i className="fas fa-info-circle"></i>
						) : (
							<i className="fas fa-info-circle"></i>
						)}
					</div>
					<div className="content">
						<h3>{title}</h3>
						<p>{content}</p>
						<div className="aaa-card mb-3">
							<div className="header">
								<div className="logo-container">
									<Image src={logo} alt="logo" />
								</div>

								<div className="contact-info">
									<h6>For Help Call:</h6>
									<p>1-800-BATTERY</p>
									<p>(1-800-228-8379)</p>
								</div>
							</div>

							<div className="body">
								<div className="forms-container">
									<div className="form-row">
										<label className="control-label">Your AAA Membership ID ( 16 Digits )</label>
										<MaskedInput
											guide={false}
											mask={[
												/[1-9]/,
												/\d/,
												/\d/,
												' ',
												/\d/,
												/\d/,
												/\d/,
												' ',
												/\d/,
												/\d/,
												/\d/,
												/\d/,
												/\d/,
												/\d/,
												/\d/,
												/\d/,
												/\d/,
												' ',
												/\d/,
											]}
											onChange={event => {
												setmembershipID(event.target.value);
											}}
										/>
									</div>

									<div className="validator-message-container">
										{validator.current.message('Membership Number', membershipID, [
											'required',
											{ size: 19 },
										])}
									</div>
									<div className="form-row mb-0">
										<label className="control-label">First and Last Name</label>
										<input
											className="form-control"
											value={memberName}
											onChange={event => {
												setMemberName(event.target.value);
											}}
										/>
									</div>

									<div className="validator-message-container">
										{validator.current.message('Member Name', memberName, 'required')}
									</div>
								</div>

								<div className="rewards-logo">
									<Image src={discountRewards} alt="rewards" />
								</div>
							</div>
						</div>

						<div className="buttons">
							{buttonDecline && (
								<button className="btn btn-default" onClick={() => onCloseModal()}>
									{buttonDecline}
								</button>
							)}

							<button
								className="btn btn-confirm"
								onClick={() => {
									var result = assignProductPriceLevel(priceLevel);
									if (result == true) {
										onCloseModal();
									}
								}}>
								{buttonConfirm}
							</button>
						</div>
					</div>
				</div>
			</Modal>
		</div>
	);
};

export default AAAModel;
